import {
		lineHeightStyle
	} from '../utils/lineHeight.js';
	import {
		quillEditor,
		Quill
	} from 'vue-quill-editor'
	import {
		container,
		ImageExtend,
		QuillWatch
	} from 'quill-image-extend-module'
	import ImageResize from 'quill-image-resize-module';
	import {
		ImageDrop
	} from 'quill-image-drop-module';
	import {
		addQuillTitle
	} from './quill-title.js';
	var Size = Quill.import('attributors/style/size');
	var Font = Quill.import('attributors/style/font');
	Size.whitelist = ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '22px', '24px', '26px',
		'28px', '36px', '48px', '56px',
		'72px'
	];
	Font.whitelist = ['仿宋', '黑体', '宋体', '楷体', '微软雅黑', '新宋体'];


	Quill.register('modules/ImageExtend', ImageExtend)
	Quill.register('modules/imageDrop', ImageDrop);
	Quill.register('modules/imageResize', ImageResize);
	Quill.register(Size, true);
	Quill.register(Font, true);
	Quill.register({
		'formats/lineHeight': lineHeightStyle
	}, true);

	// 工具栏配置
	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		['blockquote', 'code-block'],

		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'script': 'sub'
		}, {
			'script': 'super'
		}], // superscript/subscript
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction

		[{
			'size': ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '22px', '24px', '26px', '28px',
				'36px', '48px', '56px', '72px',
				false
			]
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],

		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': ['仿宋', '黑体', '宋体', '楷体', '微软雅黑', '新宋体', false]
		}],
		[{
			'align': []
		}],
		[{
			'lineheight': ['initial', '1', '1.5', '1.75', '2', '3', '4', '5']
		}],
		['link', 'image', 'video'],
		['clean'] ,// remove formatting button
		
	]
	if(window.location.pathname.indexOf("driveManagement") > -1){
		toolbarOptions[13] = ['link', 'image']
		
	}
	console.log(11111,window.location)
	// 自定义video插件
	const BlockEmbed = Quill.import('blots/block/embed')
	class VideoBlot extends BlockEmbed {
	  static create (value) {
	    let node = super.create()
	    node.setAttribute('src', value.url)
	    node.setAttribute('controls', value.controls)
	    node.setAttribute('width', value.width)
	    node.setAttribute('height', value.height)
	    node.setAttribute('webkit-playsinline', true)
	    node.setAttribute('playsinline', true)
	    node.setAttribute('x5-playsinline', true)
	    return node;
	  }
	 
	  static value (node) {
	    return {
	      url: node.getAttribute('src'),
	      controls: node.getAttribute('controls'),
	      width: node.getAttribute('width'),
	      height: node.getAttribute('height')
	    };
	  }
	}
	VideoBlot.blotName = 'simpleVideo'
	VideoBlot.tagName = 'video'
	Quill.register(VideoBlot)

	export{
		quillEditor,
		toolbarOptions,
		addQuillTitle,
		QuillWatch
	}